import { Route, Routes } from 'react-router-dom';
import { MeLayout } from './me.layout';
import { Me } from './routes/me';

export const MePaths = {
  Me: '/me',
};

export const MeRouter = () => (
  <Routes>
    <Route element={<MeLayout />}>
      <Route index element={<Me />} />
    </Route>
  </Routes>
);
